export function parseCookie(jar: string, name: string) {
  const cookie = jar.split(';').find(c => c.trim().startsWith(`${name}=`));
  return cookie?.split('=')[1];
}

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return;

  return parseCookie(document.cookie, name);
}
